const departmentConstants = {
    LOGOUT: 'DEPARTMENT_LOGOUT',

    INSERT_REQUEST: 'DEPARTMENT_INSERT_REQUEST',
    INSERT_SUCCESS: 'DEPARTMENT_INSERT_SUCCESS',
    INSERT_FAILURE: 'DEPARTMENT_INSERT_FAILURE',

    GETALL_REQUEST: 'DEPARTMENT_GETALL_REQUEST',
    GETALL_SUCCESS: 'DEPARTMENT_GETALL_SUCCESS',
    GETALL_FAILURE: 'DEPARTMENT_GETALL_FAILURE',

    UPDATE_REQUEST: 'DEPARTMENT_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'DEPARTMENT_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'DEPARTMENT_UPDATE_FAILURE',

    DELETE_REQUEST: 'DEPARTMENT_DELETE_REQUEST',
    DELETE_SUCCESS: 'DEPARTMENT_DELETE_SUCCESS',
    DELETE_FAILURE: 'DEPARTMENT_DELETE_FAILURE'
};

export default departmentConstants


// WEBPACK FOOTER //
// ./src/_constants/department.constants.js